import React from "react";
import imageGallery from "../../assets/images/imageGallery.png";
const AboutCard = () => {
  return (
    <div className="md:w-3/4 w-full md:px-20 px-8 py-32 border-2 mb-20 bg-white">
      <div className="font-bold text-2xl md:text-5xl text-orange-500 mb-20">
        ABOUT THE CONFERENCE
      </div>
      <div className="mb-20 text-justify text-xl md:text-3xl ">
        This International Conference is in continuation of previous seven such
        conferences in which five were organized by Missouri University of
        Science & Technology, Rolla, USA, and the 6<sup>th</sup> one was
        organized in Greater Noida Campus of IIT Roorkee under the leadership of
        Prof. Shamsher Prakash. The 7<sup>th</sup> conference was organized
        online due to COVID-19 situation. The conference shall have invited
        Plenary Lectures, Keynote Lectures, State of the Art and Practice (SAP)
        Lectures, Special Presentation Lectures (SPL) and contributed original
        research papers for discussion and publication in the proceedings. The 8
        <sup>th</sup> International Conference on Recent Advances in
        Geotechnical Earthquake Engineering and Soil Dynamics (8ICRAGEE) will be
        held at Indian Institute of Technology Guwahati, Guwahati during
        December 11-14, 2024. It will provide a platform to review the
        contributions and accomplishments in the field of soil dynamics in the
        last four years and draw an agenda for future course of action keeping
        the national need in the forefront. The damage scenarios of recent
        earthquakes have once again highlighted the need to evolve appropriate
        strategies to enhance the knowledge on earthquake resistant design and
        construction and to ensure that the same is put into practice by the
        practicing engineers. 8ICARGEE is being organized by Indian Society of
        Earthquake Technology (ISET) in Association with Dept. of Civil
        Engineering, Indian Institute of Technology Guwahati and Dept. of
        Earthquake Engineering, Indian Institute of Technology Roorkee.
      </div>
      <div>
        <img src={imageGallery} />
      </div>
    </div>
  );
};
export default AboutCard;
